export enum RagColours {
    DarkRed = 1,
    Red,
    Amber,
    Green,
    DarkGreen
}